import { Link } from "react-router-dom";
import { MobileDrawer } from "./SidebarContent";
import Logo from "@/app/icons/Logo";
import { NotificationPopover } from "./NotificationPopover";
import { useAuthStore } from "@/store/useAuthStore";

const DashboardHeader = () => {
  const user = useAuthStore((state) => state.user);

  return (
    <header className="h-auto md:h-[90px] border-b md:border border-border-light px-5 py-3 flex items-center justify-between shrink-0 bg-background md:rounded-lg">
      <Link to="/" className="block md:hidden">
        <Logo isCollapsed={false} />
      </Link>

      {/* Mobile hamburger — hidden on xl+ */}
      <div className="flex justify-end items-center gap-3">
        <div className="md:hidden  pr-3 border-r-2 border-[#887771]/50">
          <NotificationPopover />
        </div>
        <div className="">
          <MobileDrawer />
        </div>
      </div>

      {/* Right: bell + store */}
      <div className="hidden md:flex items-center gap-3 ml-auto">
        <div className="pr-3 border-r-2 border-[#887771]/50">
          <NotificationPopover />
        </div>

        <Link
          to="/account-settings"
          className="flex items-center gap-2 px-5 py-2.5 bg-[#2A1F1B1A] hover:bg-[#2A1F1B2A] rounded-full transition-colors text-base font-medium"
        >
          <div className="h-7 w-7 shrink-0 rounded-full overflow-hidden bg-muted border border-border-light relative">
            {user?.avatarUrl ? (
              <img
                src={user.avatarUrl}
                alt="Store"
                className="object-cover h-full w-full"
              />
            ) : (
              <div className="flex items-center justify-center h-full w-full">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.3596 8.27L22.0696 5.5C21.6496 2.48 20.2796 1.25 17.3497 1.25H14.9896H13.5097H10.4697H8.98965H6.58965C3.64965 1.25 2.28965 2.48 1.85965 5.53L1.58965 8.28C1.48965 9.35 1.77965 10.39 2.40965 11.2C3.16965 12.19 4.33965 12.75 5.63965 12.75C6.89965 12.75 8.10965 12.12 8.86965 11.11C9.54965 12.12 10.7097 12.75 11.9997 12.75C13.2896 12.75 14.4197 12.15 15.1096 11.15C15.8797 12.14 17.0696 12.75 18.3096 12.75C19.6396 12.75 20.8396 12.16 21.5896 11.12C22.1896 10.32 22.4597 9.31 22.3596 8.27Z"
                    fill="#111827"
                  />
                </svg>
              </div>
            )}
          </div>
          <span>{user?.businessName || "My Store"}</span>
        </Link>
      </div>
    </header>
  );
};

export default DashboardHeader;
